<template>
  <div class="partner-referral-view mt-2">
    <partner-referral />
  </div>
</template>

<script>
import PartnerReferral from '@/components/PartnerReferral/PartnerReferral.vue'

export default {
  name: 'PartnerReferralView',
  components: {
    PartnerReferral
  }
}
</script>

<style>
</style>
